<template>
    <div class="login-footer">
        <a href="https://www.laizquierdadiario.com" target="_blank">
            <img src="@/assets/logo_ar.svg" alt="La Izquierda Diario" />
        </a>
        <a href="https://www.laizquierdadiario.com/Red-Internacional/">
            <img src="@/assets/logo_red_internacional_lid.svg" alt="Red Internacional La Izquierda Diario" />
        </a>
    </div>
    <div class="login-footer-2">
        <nav>
            <RouterLink :to="{ name: 'terms-of-service' }">Términos del Servicio</RouterLink>
            <RouterLink :to="{ name: 'privacy-policy' }">Política de Privacidad</RouterLink>
            <a target='_blank'
                href="https://docs.google.com/forms/d/18aMGrwHl0ZLLWMgXbXfmLqWfwyIU42wYc15WlVfU9KY/edit">Contactanos</a>
        </nav>
    </div>

</template>

<script>
export default {
    props: {
        prompt: {
            type: String,
            required: true
        },
        prompt_suggestion_id: {
            type: Number,
            required: true
        },
        use_count: {
            type: Number,
            required: true
        },
        icon: {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped>
.login-footer {
    max-width: 1200px;
    max-height: 550px;
    width: 50%;
    margin-top: 48px;
    border-radius: 12px;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    background-color: rgba(50, 50, 50, 0.85);
    box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.2);
    padding: 12px;
    margin-top: auto;
    margin-bottom: 48px;
}

.login-controls {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.login-controls-top {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.login-controls-bottom {
    margin-top: 24px;
    color: #f0f0f0;
}


.login-component input {
    margin-right: 24px;
    font-size: 14pt;
    padding: 12px;
    flex-grow: 2;
    height: 100%;
    margin-bottom: 0;
}

.login-component button {
    font-size: 14pt;
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    background-color: #a1344e;
    color: #ffffff;
    cursor: pointer;
    align-self: stretch;
    flex-grow: 1;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-weight: bold;
}

.login-component h1 {
    font-size: 48pt;
    margin-bottom: 24px;
    color: #a1344e;
    letter-spacing: 20px;
}

.login-component h2 {
    color: #f0f0f0;
    font-weight: 400;
    font-size: 16pt;
    margin-bottom: 48px;
}

.login-footer a {
    width: 40%;
    max-width: 250px;
    margin: 12px;
}

.login-footer img {
    width: 100%;
}

.login-footer-2 {
    padding-bottom: 24px;
    color: #f0f0f0 !important;
}

.login-footer-2 a {
    color: #f0f0f0 !important;

}

.login-footer-2 a:visited {
    color: #f0f0f0 !important;
}



.login-footer-2 nav>* {
    margin: 12px;
}

/* MOBILE */
@media (max-width: 768px) {
    .login-footer {
        width: calc(100% - 24px);
        margin: auto 12px 12px 12px;
        padding: 12px;
        background-color: rgba(175, 175, 175, 0.8);
        flex-direction: column;
    }

    .login-footer a {
        width: 80%;
        max-height: 60px;
        margin: 6px;
    }

    .login-footer a:first-child {
        margin-bottom: 12px;
    }


    .login-footer a img {
        height: 100%;
    }


    .prompt-suggestions-carrousel h1 {
        font-size: 12pt;
        margin-bottom: 0;
        margin-top: 0;
    }

    .login-footer-2 nav {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
    }
}
</style>